import React, { useState } from 'react';
import cx from 'classnames';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import styles from '@/common/containers/UserIntro/styles.less';
import { Trans, useTranslation } from 'react-i18next';
import {
  Immediate,
  Legal,
  Main,
  Assets,
  Closing,
} from '@/pages/task-list/components/ModuleTips';

const TimelineBlock = ({ title, Tip, className }) => {
  const [open, setOpen] = useState(false);
  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <div className={cx(styles.fourthBlock, className)}>
      <span className={styles.fourthBlockText}>{title}</span>
      <ClickAwayListener onClickAway={hide}>
        <span className={styles.fourthBlockTip}>
          <Tooltip
            title={<Tip instruction={false} />}
            // placement="left-end"
            open={open}
            onOpen={show}
            onClose={hide}
            disableTouchListener
          >
            <InfoIcon className={styles.fourthBlockIcon} onClick={show} />
          </Tooltip>
        </span>
      </ClickAwayListener>
    </div>
  );
};

const Fourth = () => {
  const { t } = useTranslation();
  return (
    <div className={cx(styles.screen, styles.fourth)}>
      <div>
        <h4 className={styles.fourthTitle}>
          {t('What does the process look like?')}
        </h4>
        <div className={styles.fourthLabel}>
          <Trans
            i18nKey='Managing the personal affairs and estate for a decedent is a time consuming process that, on average, can take <1>12 to 18 months</1> but may take even more depending on the unique situation. In order to make this process more manageable, we divide this effort into logical sections referred to as "task modules" to be completed in a particular order as shown in the graphic below.'
            components={{ 1: <b /> }}
          />
        </div>
        <div className={styles.fourthTimeline}>
          <span className={cx(styles.fourthTimelineLabel, styles.fourthStart)}>
            {t('DATE OF DEATH')}
          </span>
          <span className={cx(styles.fourthPeriod, styles.fourthWeek)}>
            {t('1 week')}
          </span>
          <span className={cx(styles.fourthPeriod, styles.fourthMonths)}>
            {t('up to 18 months')}
          </span>
          <div className={styles.fourthTimelineBg} />
          <TimelineBlock
            className={styles.fourthImmediate}
            title={t('Immediate tasks')}
            Tip={Immediate}
          />
          <div className={styles.fourthModules}>
            <TimelineBlock
              className={styles.fourthLegal}
              title={t('Legal tasks')}
              Tip={Legal}
            />
            <TimelineBlock
              className={styles.fourthMain}
              title={t('Main tasks')}
              Tip={Main}
            />
            <TimelineBlock
              className={styles.fourthAssets}
              title={t('Assets tasks')}
              Tip={Assets}
            />
          </div>
          <TimelineBlock
            className={styles.fourthClosing}
            title={t('Closing tasks')}
            Tip={Closing}
          />
          <span className={cx(styles.fourthTimelineLabel, styles.fourthEnd)}>
            {t('FINISH')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Fourth;
